import './About.css';

export function About() {
  return (
    <section id="about" className="about">
      <div className="about__container">
        <div className="about__content">
          <h2 className="about__title">Over Ruxia Gold</h2>
          <p className="about__text">
            Ruxia Gold is een vertrouwde Belgische opkoper van edelmetalen, gespecialiseerd in de
            aankoop van goud, zilver, platina en palladium. Wij kopen uitsluitend aan — verkopen doen
            wij niet. Met jarenlange ervaring in de markt betalen wij een transparante prijs op basis
            van de live spotkoers.
          </p>
          <p className="about__text">
            Of u nu één juweel aanbiedt of een volledige collectie — onze experts schatten uw
            edelmetaal correct in en begeleiden u bij elke transactie met integriteit en discretie.
          </p>
          <div className="about__stats">
            <div className="about__stat">
              <span className="about__stat-value">4</span>
              <span className="about__stat-label">Metalen</span>
            </div>
            <div className="about__stat">
              <span className="about__stat-value">21+</span>
              <span className="about__stat-label">Soorten Goudstaven</span>
            </div>
            <div className="about__stat">
              <span className="about__stat-value">Live</span>
              <span className="about__stat-label">Spotprijzen</span>
            </div>
            <div className="about__stat">
              <span className="about__stat-value">100%</span>
              <span className="about__stat-label">Transparant</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
